import React from 'react'
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style'
import Adminpage from './admin-page-widgets/adminpage'
import AddAdminButton from './admin-page-widgets/adb-btn'
import { gql, useQuery } from '@apollo/client';
import { 
  Badge,
  // IconButton, MoreIcon, 
  Spinner 
} from 'evergreen-ui';
import UnAssignAdminButton from './admin-page-widgets/unassign_admin';
import EditSubAdminButton from './admin-page-widgets/edit_admin';
import ResendAdminInvite from './admin-page-widgets/resend_admin_invite';


export const FETCH_SUBADMIN = gql`
query SubAdmins_getForPropertyManager {
  subAdmins_getForPropertyManager {
    _id
    facilityManager {
      _id
      email
      name
      phone
      photo
      bankAccounts {
        _id
        accountNumber
        accountName
        bankCode
        bankName
        isPrimary
      }
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      paymentModelType
      accessStartDate
      accessEndDate
      mostRecentAccessDuration
      managerType
      createdAt
      id
    }
    facility {
      _id
      code
      type
      name
      facilityManager
      totalProperties
      occupiedProperties
      availableProperties
      address
      country
      state
      city
      createdAt
      asBuiltDrawing
      id
    }
    fullAccess
    assignedDate
    unassignedDate
    unassignedReason
    permissions {
      fullAccess
      queryAccess
      mutationAccess
      resource
    }
    inviteStatus
    isActive
  }
}
`;
function AdminTab() {
  return (
    <div>
      <table className='responsive-table'>
          <thead>
            <tr>
                <TableHead>Name</TableHead>
                <TableHead>Email </TableHead>
                <TableHead>Phone No</TableHead>
                <TableHead>Assigned Asset</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Actions</TableHead>
            </tr>
          </thead>
          <SubadminTable/>
          <Adminpage/>
      </table>
      <br/>
      <center>
        <AddAdminButton/>
      </center>
    </div>
    
  )
}

export default AdminTab



function SubadminTable() {
const { loading,error,data }   = useQuery(FETCH_SUBADMIN);

if (loading) return <Spinner/>;
if (error) return <p>{error.toString()}</p>;
const transactions = data.subAdmins_getForPropertyManager
  return (
    <tbody>
        {
          transactions.map((data)=>
            <TableBodyRow
            >
                <td>
                  {data.facilityManager.name}
                </td>
                <td>{data.facilityManager.email}</td>
                <td>{data.facilityManager.phone}</td>
                <td>{data.facility.name}</td>
                <td>
                  <Badge color="purple">
                    {data.isActive?"Active"
                    :data.unassignedDate !==null 
                    ?"Un-assigned"
                    :"Not active"
                    }
                  </Badge>
                </td>
                <td>
                  {data.unassignedDate !==null 
                  ?''
                  :<UnAssignAdminButton id={data._id}/>
                  }
                  {!data.isActive && data.unassignedDate ===null 
                    ?<ResendAdminInvite data={data}/>
                    :""
                  }
                  <EditSubAdminButton  id={data._id} />
                </td>
              
            </TableBodyRow>
          )
        }
    </tbody>
  )
}
